import { render, staticRenderFns } from "./CovidBanner.vue?vue&type=template&id=bcadc742&scoped=true&"
import script from "./CovidBanner.vue?vue&type=script&lang=js&"
export * from "./CovidBanner.vue?vue&type=script&lang=js&"
import style0 from "./CovidBanner.vue?vue&type=style&index=0&id=bcadc742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcadc742",
  null
  
)

export default component.exports